import { useCallback, useEffect, useState } from 'react';

import { logoTemplatesApi, type LogoTemplate, type LogoTemplateInput } from '../api/logo-templates';

/** Общий список шаблонов логотипов и операции над ним. */
export function useLogoTemplates() {
  const [logos, setLogos] = useState<LogoTemplate[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    setIsLoading(true);
    try {
      setLogos(await logoTemplatesApi.list());
      setError(null);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Не удалось загрузить логотипы');
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    void reload();
  }, [reload]);

  const save = useCallback(async (input: LogoTemplateInput, id?: string): Promise<LogoTemplate> => {
    const saved = id ? await logoTemplatesApi.update(id, input) : await logoTemplatesApi.create(input);
    setLogos((prev) =>
      [...prev.filter((l) => l.id !== saved.id), saved].sort((a, b) =>
        a.name.localeCompare(b.name, 'ru'),
      ),
    );
    return saved;
  }, []);

  const remove = useCallback(async (id: string) => {
    await logoTemplatesApi.remove(id);
    setLogos((prev) => prev.filter((l) => l.id !== id));
  }, []);

  return { logos, isLoading, error, reload, save, remove };
}
